import styled from 'styled-components';

export const StyledForm = styled.form`
  margin-top: 1.875rem;
  width: 100%;
`;
